const WORDS = [
  "Cloud Architecture",
  "Custom Software",
  "DevOps",
  "Data Engineering",
  "Digital Strategy",
  "System Integration",
];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div
      data-testid="marquee"
      className="relative border-y border-white/10 py-8 md:py-10 overflow-hidden select-none"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-4xl md:text-6xl font-black tracking-tighter text-stroke px-8">
              {w}
            </span>
            <span className="text-[#00F0FF] text-3xl md:text-5xl">✳</span>
          </div>
        ))}
      </div>
    </div>
  );
}
